import * as React from 'react';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { FavouriteEditMenuComponentProps } from 'app/area/favourite-administration/form/types';
import styles from './favourite-edit-menu.scss';

export const FavouriteEditMenu = (props: FavouriteEditMenuComponentProps) => {
  const { id, fetching, translation, onDelete } = props;

  const handleDelete = () => {
    onDelete(id);
  };

  return (<MeatballMenu className={styles.meatball}>
    <li>
      <PromptConfirmationModal
        title={translation.delete_favourite}
        description={translation.delete_confirmation}
        continueText={translation.delete_favourite}
        cancelText={translation.cancel}
        onContinue={handleDelete}>
        <button type="button" className="dropdown-item" disabled={fetching}>
          {translation.delete_favourite}
        </button>
      </PromptConfirmationModal>
    </li>
  </MeatballMenu>);
};
